import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { StoryblokLink } from '../../storyblok-types';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-storyblok-button',
  standalone: true,
  templateUrl: './storyblok-button.component.html',
  styleUrls: ['./storyblok-button.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, ButtonDirective, RouterLink, SvgComponent],
})
export class StoryblokButtonComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() customAlignment: string;

  @Input() link: StoryblokLink;
  @Input() text: string;
  @Input() alignment: 'left' | 'center' | boolean = 'center';
  @Input() buttonSize: string;
  @Input() buttonSpacing: string;
  @Input() buttonStyle: string;
  @Input() corners: string;
  @Input() textSize: string;
  @Input() bold: boolean;
  @Input() icon: string;
  @Input() iconPosition: 'left' | 'right' = 'left';

  @Input() mobileAlignment: 'left' | 'center' = 'center';
  @Input() tabletAlignment: 'left' | 'center' = 'center';
  @Input() desktopAlignment: 'left' | 'center' = 'center';

  href: string;
  internalLink: boolean;

  private storyblokService = inject(StoryblokService);

  private calcHref() {
    return this.storyblokService.getUrlLink(this.link);
  }

  ngOnChanges() {
    if (this.alignment === true) this.alignment = 'center';
    if (this.alignment === false) this.alignment = 'left';

    this.href = this.calcHref();
    this.internalLink = this.href.startsWith('/');
  }
}
